module.exports = __webpack_public_path__ + "assets/img/new33.65ce50cf.png";